import { gql } from '@apollo/client'

export default gql(`
    mutation disableUser($id: String $project: String) {
        disableUser(
            input: {
                id: $id
            }
            project: $project
        ){
            id
        }
    }
`)
